import { get, map } from "lodash";

import { getRandomColor } from "../helpers/generel.helpers";
import { songsServices } from "../services/song.service";
import { showToaster } from "../helpers/toaster.helpers";
import { generalHelpers } from "../helpers";

export const fetchSongs = async (searchKey = "", userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline, please check your internet connection"
    );
  }
  try {
    const { data } = await songsServices.fetchSongs(searchKey);

    const songs = generalHelpers.getFormattedSongs(data.data);

    return addColorToSong(songs);
  } catch (error) {
    return {};
  }
};

export const fetchSongById = async (id, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const res = await songsServices.fetchSongById(id);
    return get(res, "data.data", {});
  } catch (error) {
    return {};
  }
};

export const fetchSongsAccrodingToReaction = async (type, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const res = await songsServices.fetchSongsAccrodingToReaction(type);

    const songs = generalHelpers.getFormattedSongs(res.data.data);
    return songs;
  } catch (error) {
    return {};
  }
};

const addColorToSong = (songs, userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline, please check your internet connection"
    );
  }
  return map(songs, (song, index) => {
    const color = getRandomColor();
    return { ...song, color };
  });
};

export const addReactionToSong = async (id, type, userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline, please check your internet connection"
    );
  }
  try {
    await songsServices.addReactioToSong(id, type);
    return true;
  } catch (error) {
    return false;
  }
};

export const addFavouriteToSong = async (id, userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline, please check your internet connection"
    );
  }
  try {
    await songsServices.addFavouriteToSong(id);
    return true;
  } catch (error) {
    return false;
  }
};

export const downloadSong = async (id, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const res = await songsServices.downloadSong(id);
    return get(res, "data", {});
  } catch (error) {
    return {};
  }
};

export const startSongView = async (id, userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline, please check your internet connection"
    );
  }
  try {
    await songsServices.startView(id);
    return true;
  } catch (error) {
    return false;
  }
};

export const confirmSongView = async (id, duration, userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline, please check your internet connection"
    );
  }
  try {
    await songsServices.confirmView(id, { duration });
    return true;
  } catch (error) {
    return false;
  }
};
